import { useQuery } from "@tanstack/react-query"
import { CircularProgress } from "@mui/material"
import { t } from "../../i18n"
import { ManagementCompany } from "../../Interfaces"
import { useSelectedCompany } from "../../context/companyProvider"
import useUser from "../../hooks/useUser"
import { managementCompanyService } from "../../services/managementCompanyService"
import { canSelectPayrollCompany, companiesForPayrollExport } from "../../utils/payrollCompanies"
import PayrollExportPanel from "./PayrollExportPanel"

export default function ConstructionDashboardPayroll() {
  const user = useUser()
  const { selectedCompany, isAdmin } = useSelectedCompany()
  const { data: companies = [], isLoading, error } = useQuery<ManagementCompany[]>(
    ["managementCompanies", user.id],
    () => managementCompanyService.listForUser(user.id),
    {
      enabled: !!user.id,
      suspense: false,
      useErrorBoundary: false,
    },
  )

  const allowed = companiesForPayrollExport({
    companies,
    isAdmin,
    ownCompanyId: user.managementCompanyId || user.managementCompany?.id,
    selectedCompany,
  })

  if (isLoading) {
    return (
      <section className="mb-6 bg-white rounded-2xl shadow-lg p-5 md:p-6 font-source">
        <h2 className="font-oswald text-2xl font-bold text-primary-dark">{t("payroll.title")}</h2>
        <div className="flex justify-center py-8">
          <CircularProgress />
        </div>
      </section>
    )
  }

  return (
    <PayrollExportPanel
      companies={allowed}
      allowCompanySelect={canSelectPayrollCompany(isAdmin, allowed)}
      companyId={selectedCompany?.id}
      companiesError={error ? t("payroll.companiesLoadFailed") : undefined}
    />
  )
}
